function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M4.24,5.26,0,9.5l4.24,4.24L8.48,9.5ZM2.83,9.5,4.24,8.09,5.66,9.5,4.25,10.91Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M18,4.67V3.26L15.98,5.28,10.71,0H9.29l6.69,6.69Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M12.29,9.41,3.69,18H5.11L13.7,9.41,4.29,0H2.88Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M10.71,18,18,10.71V9.29L9.29,18Z"
});

var SvgUkladPrzestrzenny = function SvgUkladPrzestrzenny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_uklad-przestrzenny-gray",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUkladPrzestrzenny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uklad-przestrzenny.f5355674.svg";
export { ForwardRef as ReactComponent };